import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import RichTextEditor from '../../components/RichTextEditor';
import './Ajouter.css';

import axios from 'axios';

import api from '../../api';



function Ajouter({ onAddLocation }) {
  const navigate = useNavigate();

  const [imageBase64Array, setImageBase64Array] = useState([]);
  
  const [newLocation, setNewLocation] = useState({
    title: '',
    localisation: '',
    description: '',
    regulation: '',
    rooms: 0,
    bathrooms: 0,
    bed: 0,
    lounge: 0,
    availability: 'Disponible',
    category: '',
    images: [], // Stockera les noms des fichiers images
    details: {
      reference: '',
      city: '',
      district: '',
      name: '',
      country: 'Sénégal',
      price: '',
    },
    amenities: [],
  });

  const [selectedFiles, setSelectedFiles] = useState([]); // Pour stocker les images sélectionnées

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewLocation({
      ...newLocation,
      [name]: value,
    });
  };

  const handleDetailsChange = (e) => {
    const { name, value } = e.target;
    setNewLocation({
      ...newLocation,
      details: {
        ...newLocation.details,
        [name]: value,
      }
    });
  };

  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);
    setSelectedFiles(files); // ✅ C’est ce tableau qui sera envoyé dans uploadImages
  };
  
  const uploadImages = async () => {
    const formData = new FormData();
    selectedFiles.forEach(file => {
      formData.append('images', file);
    });
    formData.append('type', 'properties');

    try {
      const response = await api.post('/upload', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      // ✅ Retourne tableau d’objets { url, publicId }
      return response.data.uploadedImages;
    } catch (error) {
      console.error("Erreur lors de l'upload des images :", error);
      alert("Une erreur est survenue lors de l'upload des images.");
      throw error;
    }
  };
  
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      // Étape 1 : Upload vers Cloudinary
      const uploadedImages = await uploadImages(); // 🔁 [{ url, publicId }, ...]

      // Étape 2 : Construire l'objet à envoyer à l'API
      const propertyData = {
        ...newLocation,
        images: uploadedImages.map(img => ({
          url: img.url,
          publicId: img.publicId
        })),
        amenities: newLocation.amenities.map(a => a.trim()),
        details: {
          ...newLocation.details,
          name: newLocation.details.name || 'Non spécifié',
          sequence: 'Mois',
          price: parseFloat(
            newLocation.details.price
              .toString()
              .replace(/[^\d.]/g, '')
          ),
        },
      };

      // Supprimer les champs inutiles (optionnel selon backend)
      delete propertyData.bed;
      delete propertyData.regulation;

      // Étape 3 : Envoyer les données à l'API
      const response = await api.post('/properties', propertyData, {
        headers: { 'Content-Type': 'application/json' },
      });

      alert("L'élément a été ajouté avec succès !");
      onAddLocation(response.data);
      navigate('/locations');
    } catch (error) {
      console.error("Erreur lors de l'ajout de la propriété :", error.response?.data || error);
      alert("Une erreur est survenue lors de l'ajout de la propriété.");
    }
  };

   
  

  return (
    <div className="ajouter-container">
      <h1>Ajouter une nouvelle location</h1>
      <form onSubmit={handleSubmit}>

        <label>Titre :</label>
        <input type="text" name="title" placeholder="Ex : Appartement F3 très classe à louer au Point E" value={newLocation.title} onChange={handleInputChange} required />

        <label>Référence :</label>
        <input type="text" name="reference" placeholder="La référence de l'élément." value={newLocation.details.reference} onChange={handleDetailsChange} required />

        <label>Localisation :</label>
        <input type="text" name="localisation" placeholder="Ex : Point E, Dakar ou Grand Standing, Thiès" value={newLocation.localisation} onChange={handleInputChange} required />

        <label>Prix :</label>
        <input type="text" name="price" placeholder="Ex : 15 000 FCFA / Nuit, 50 000 FCFA / Mois, 30 000 FCFA / Semaines" value={newLocation.details.price} onChange={handleDetailsChange} required />

        <label>Description :</label>
        <RichTextEditor
          value={newLocation.description}
          onChange={(value) => setNewLocation({ ...newLocation, description: value })}
          placeholder="Toutes les informations nécessaires et utiles."
        />

        {/*<label>Règlement intérieur :</label>
        <textarea name="regulation" placeholder="Le règlement intérieur." value={newLocation.regulation} onChange={handleInputChange} required />*/}

        <label>Chambres :</label>
        <input type="number" name="rooms" value={newLocation.rooms} onChange={handleInputChange} required />

        <label>Salles de bains :</label>
        <input type="number" name="bathrooms" value={newLocation.bathrooms} onChange={handleInputChange} required />

        <label>Salons :</label>
        <input type="number" name="lounge" value={newLocation.lounge} onChange={handleInputChange} required />

        {/*<label>Lits :</label>
        <input type="number" name="bed" value={newLocation.bed} onChange={handleInputChange} required />*/}

        <label>Catégorie :</label>
        <select
          name="category"
          value={newLocation.category}
          onChange={handleInputChange}
          required
        >
          <option value="">-- Choisissez une catégorie --</option>
          <option value="Appartements">Appartements</option>
          <option value="Villas">Villas</option>
          <option value="Studios">Studios</option>
          <option value="Chambres">Chambres</option>
          <option value="Saisonnière">Saisonnière</option>
        </select>


        <label>Ville :</label>
        <input type="text" name="city" placeholder="Ex : Dakar, Thiès" value={newLocation.details.city} onChange={handleDetailsChange} required />

        <label>Quartier :</label>
        <input type="text" name="district" placeholder="Ex : Point E" value={newLocation.details.district} onChange={handleDetailsChange} required />

        <label>Libellé :</label>
        <input type="text" name="name" placeholder="Ex : Rond Point Mbaw ou Près de telle" value={newLocation.details.name} onChange={handleDetailsChange} />

        <label>Pays :</label>
        <input type="text" name="country" value={newLocation.details.country} onChange={handleDetailsChange} required />

        <label>Installations & Commodités (séparées par une virgule) :</label>
        <input type="text" name="amenities" placeholder="Ex : 'Ascenseur', 'Caméra de surveillance', 'Climatisation', 'Groupe électrogène', 'Parking', 'etc'" value={newLocation.amenities.join(', ')} onChange={(e) => setNewLocation({ ...newLocation, amenities: e.target.value.split(',').map(a => a.trim()) })} />

        <label>Images :</label>
        <input type="file" multiple onChange={handleImageChange} />

        <button type="submit">Ajouter</button>
      </form>
    </div>
  );
}

export default Ajouter;
